(function () {
  'use strict';

  // ===== Jump-nav scrollspy: highlight the chip for the section currently
  // closest to the top of the viewport.
  (function () {
    var chips = document.querySelectorAll('.ArmbrustPDP__JumpNav a[href^="#"]');
    if (!chips.length) return;
    var pairs = [];
    chips.forEach(function (chip) {
      var id = chip.getAttribute('href').slice(1);
      if (!id || id === 'top') return;
      var el = document.getElementById(id);
      if (el) pairs.push({ chip: chip, el: el });
    });
    if (!pairs.length) return;

    function update() {
      var threshold = 130;  // a bit below the sticky topbar + nav stack
      var current = pairs[0];
      pairs.forEach(function (p) {
        var top = p.el.getBoundingClientRect().top;
        if (top - threshold <= 0) current = p;
      });
      pairs.forEach(function (p) {
        p.chip.classList.toggle('is-active', p === current);
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();

  // ===== Hero gallery: clicking a thumb swaps the main image.
  // Order of preference for the swapped-in src: data-display (900px hero
  // size), then data-full (1600px lightbox version), then the thumb src.
  // Thumbs marked .has-more route to the lightbox instead of swapping, so
  // hidden overflow photos are still reachable.
  var heroImage = document.querySelector('.ArmbrustPDP__HeroImage');
  var thumbButtons = document.querySelectorAll('.ArmbrustPDP__ThumbGrid button');
  if (heroImage && thumbButtons.length) {
    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('has-video')) {
          // Open the unified photo modal at the video item.
          openVideoThumb(btn);
          return;
        }
        if (btn.classList.contains('has-more')) {
          // Open the lightbox at this thumb's photo. Hidden overflow thumbs
          // are still in the gallery so prev/next reaches them.
          openThumbAt(btn);
          return;
        }
        var img = btn.querySelector('img');
        if (!img) return;
        var display = img.getAttribute('data-display') || img.getAttribute('data-full') || img.src;
        heroImage.src = display;
        heroImage.alt = img.alt || heroImage.alt;
        thumbButtons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    if (thumbButtons[0]) thumbButtons[0].classList.add('is-active');
  }

  // Manage which thumb wears `.has-more` based on viewport. The `~ button`
  // CSS rule hides every sibling after `.has-more`, so this is a one-line
  // "how many thumbs are visible" control.
  //   desktop (>=1008px): show 7 → .has-more on the 7th
  //   mobile  (<1008px):  show 8 → .has-more on the 8th
  (function () {
    if (!thumbButtons.length) return;
    var mq = window.matchMedia('(min-width: 1008px)');
    function apply() {
      var cutoffIdx = mq.matches ? 6 : 7; // 0-based: position of the .has-more thumb
      thumbButtons.forEach(function (btn, i) {
        if (i === cutoffIdx) {
          btn.classList.add('has-more');
          btn.setAttribute('data-more-count', thumbButtons.length - cutoffIdx - 1);
        } else {
          btn.classList.remove('has-more');
        }
      });
    }
    apply();
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change')
      : mq.addListener.bind(mq))(apply);
  })();


  // ===== Quantity dropdown -> live price recompute.
  // Unit price (per 50-mask box) lives on the price row as data-unit-price.
  // Displayed total = unit * qty. Suffix flips from "/ 50-mask box" (qty 1)
  // to "for N boxes ($U each)" (qty 2+).
  (function () {
    var priceRow = document.querySelector('[data-pdp-price-row]');
    var qtySelect = document.getElementById('quantity-select');
    if (!priceRow || !qtySelect) return;
    var totalEl = priceRow.querySelector('[data-pdp-price-total]');
    var suffixEl = priceRow.querySelector('[data-pdp-price-suffix]');
    var unit = parseFloat(priceRow.getAttribute('data-unit-price')) || 0;
    if (!unit) return;
    function fmt(n) { return '$' + n.toFixed(2); }
    function update() {
      var qty = parseInt(qtySelect.value, 10) || 1;
      var total = unit * qty;
      if (totalEl) totalEl.textContent = fmt(total);
      if (suffixEl) {
        suffixEl.textContent = qty === 1
          ? '/ 50-mask box'
          : 'for ' + qty + ' boxes (' + fmt(unit) + ' each)';
      }
    }
    qtySelect.addEventListener('change', update);
    update();
  })();

  // ===== Subscribe & Save panel.
  // Click anywhere on the panel (header OR CTA) to toggle subscription on/off.
  // When ON: the hidden selling_plan input is set, so Add to Cart treats the
  // submission as a subscription. The main "Add to cart" button is the
  // submit; this panel only changes the selection state.
  var subscribeBox = document.querySelector('.SubscribeSave');
  var pdpForm = document.querySelector('.js-pdp-form, [data-pdp-form]');
  var pdpSellingPlan = document.querySelector('[data-pdp-selling-plan]');
  if (subscribeBox) {
    var headerBtn = subscribeBox.querySelector('[data-toggle="subscribe"]');
    var ctaBtn = subscribeBox.querySelector('[data-action="subscribe-add"]');
    function setSubscribed(on) {
      subscribeBox.setAttribute('data-subscribe-state', on ? 'on' : 'off');
      if (pdpSellingPlan && ctaBtn) {
        var planGid = ctaBtn.getAttribute('data-selling-plan-id') || '';
        var planNumeric = planGid.replace(/^.*\//, '');
        pdpSellingPlan.value = on ? planNumeric : '';
      }
      if (ctaBtn) {
        ctaBtn.textContent = on
          ? 'Cancel subscription, use one-time'
          : 'Subscribe & add to cart';
      }
    }
    function toggleSubscribed() {
      var on = subscribeBox.getAttribute('data-subscribe-state') === 'on';
      setSubscribed(!on);
    }
    if (headerBtn) headerBtn.addEventListener('click', toggleSubscribed);
    if (ctaBtn) ctaBtn.addEventListener('click', toggleSubscribed);
  }

  // ===== BossApps volume-discount widget: move into the "Save more on
  // multi-packs" reveal panel so it's not floating in the buy box.
  function relocateVolumeDiscount() {
    var widget = document.querySelector('lb-volume-discount, [class*="lb-vd-container"]');
    var mount = document.querySelector('[data-bossapps-volume-discount-mount]');
    if (widget && mount && widget.parentElement !== mount) {
      // Walk up to the most stable container if the widget root is nested
      var root = widget.tagName === 'LB-VOLUME-DISCOUNT' ? widget : widget.closest('lb-volume-discount') || widget;
      mount.appendChild(root);
    }
  }
  // The BossApps script hydrates asynchronously; retry until it lands.
  var bossTries = 0;
  var bossTimer = setInterval(function () {
    bossTries += 1;
    relocateVolumeDiscount();
    if (document.querySelector('[data-bossapps-volume-discount-mount] lb-volume-discount') || bossTries > 40) {
      clearInterval(bossTimer);
    }
  }, 250);

  // ===== Customer photo grid + review card clicks: open the photo modal at
  // the corresponding image. The hero modal logic below handles other thumb
  // clicks; this delegates click handling for photo-grid and review-photo
  // surfaces so clicking anywhere on a customer photo opens the modal.
  // Photo URL -> review card lookup (populated after qualified data loads
  // below in the chip-filter block). Used by every photo click on the page
  // so the review modal can open with the actual reviewer's content.
  function findReviewCardByPhotoUrl(url) {
    if (!url || !window.__armbrustQualified) return null;
    var q = window.__armbrustQualified;
    // Match exact, then ignore querystring (cache-buster differences)
    if (q.photo_to_id && q.photo_to_id[url]) {
      var id = q.photo_to_id[url];
      return (q.cards || []).find(function (c) { return String(c.id) === String(id); });
    }
    var urlNoQuery = url.split('?')[0];
    var match = null;
    Object.keys(q.photo_to_id || {}).some(function (k) {
      if (k.split('?')[0] === urlNoQuery) {
        var id = q.photo_to_id[k];
        match = (q.cards || []).find(function (c) { return String(c.id) === String(id); });
        return true;
      }
      return false;
    });
    return match;
  }

  function makeImagesClickable(selector) {
    document.querySelectorAll(selector).forEach(function (img) {
      if (img.dataset.modalBound) return;
      img.dataset.modalBound = '1';
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function (e) {
        // Inside a review card with its own data-open-review-modal button?
        // Let the existing delegated handler take it so we don't double-open.
        if (img.closest('[data-open-review-modal]')) return;
        e.preventDefault();
        e.stopPropagation();
        var url = img.getAttribute('data-full') || img.getAttribute('data-display') || img.src;
        var alt = img.alt || 'Customer photo';
        // Prefer the review modal when this photo belongs to a known review.
        var card = findReviewCardByPhotoUrl(url);
        if (card && typeof window.__armbrustOpenReviewModal === 'function') {
          window.__armbrustOpenReviewModal(card);
        } else if (typeof window.__armbrustOpenModalAt === 'function') {
          window.__armbrustOpenModalAt(url, alt);
        }
      });
    });
  }
  // Run once after DOM ready and once more after BossApps hydration (in case
  // images were lazy-loaded into view).
  function bindAllPhotoClicks() {
    makeImagesClickable('.ArmbrustPDP__HeroPhotos img, .ArmbrustPDP__PhotoGrid img, .ArmbrustPDP__PhotoStrip img, .ArmbrustReviewCard img, .ArmbrustPDP__QuoteAvatar, .ArmbrustReviewCard--qualified img');
  }
  document.addEventListener('DOMContentLoaded', bindAllPhotoClicks);
  setTimeout(bindAllPhotoClicks, 1500);

  // ===== Review topic chip filter (qualified pool).
  // Clicking a chip pulls 10 fresh reviews from armbrust.qualified_reviews
  // (all photo-verified to show a person wearing a blue surgical mask).
  // Re-clicking the same chip advances to the next 10. Clicking a different
  // chip resets only that chip's offset (others retain their position).
  // Reviews are never repeated within a chip's sequence until the pool is
  // exhausted, at which point the offset wraps.
  var chipFilterChips = document.querySelectorAll('#topic-chips button[data-topic]');
  var reviewList = document.getElementById('reviews-list');
  var status = document.getElementById('reviews-status');
  var empty = document.getElementById('reviews-empty');
  var qualifiedDataEl = document.getElementById('armbrust-qualified-reviews-data');
  var qualified = null;
  if (qualifiedDataEl) {
    try {
      qualified = JSON.parse(qualifiedDataEl.textContent || '{}');
      window.__armbrustQualified = qualified;
    } catch (e) { console.warn('armbrust-product: bad qualified_reviews JSON', e); }
  }

  var chipOffsets = {};   // slug -> next index to start showing from
  var initialReviewListHTML = reviewList ? reviewList.innerHTML : '';
  var activeTopic = null;

  function cardById(id) {
    if (!qualified || !qualified.cards) return null;
    for (var i = 0; i < qualified.cards.length; i++) {
      if (String(qualified.cards[i].id) === String(id)) return qualified.cards[i];
    }
    return null;
  }

  function renderCard(card) {
    var stars = '★★★★★'.slice(0, card.rating);
    var date = card.date ? new Date(card.date).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'}) : '';
    var safe = function (s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
    var nameParts = (card.name || 'Customer').split(/\s+/);
    var display = nameParts[0] + (nameParts.length > 1 ? ' ' + nameParts[nameParts.length - 1][0].toUpperCase() + '.' : '');
    return '<article class="ArmbrustReviewCard" data-review-id="' + card.id + '">' +
      '<div class="ArmbrustPDP__ReviewPhotos">' +
        '<button type="button" data-open-review-modal>' +
          '<img src="' + safe(card.photo) + '" alt="Customer review photo from ' + safe(display) + '">' +
        '</button>' +
      '</div>' +
      '<div class="ArmbrustPDP__ReviewBody">' +
        '<p class="ArmbrustPDP__ReviewName"><strong>' + safe(display) + '</strong></p>' +
        '<div class="ArmbrustPDP__StarsTitle">' +
          '<span class="ArmbrustPDP__Stars">' + stars + '</span>' +
          (card.title ? '<h3>' + safe(card.title) + '</h3>' : '') +
        '</div>' +
        '<p class="ArmbrustPDP__ReviewWhere">' + (date ? 'Reviewed in the United States on ' + date : '') + '</p>' +
        '<p class="ArmbrustPDP__ReviewText">' + safe(card.body) + '</p>' +
      '</div>' +
    '</article>';
  }

  function applyChipFilter(topic) {
    if (!reviewList) return;
    if (!topic) {
      reviewList.innerHTML = initialReviewListHTML;
      if (status) status.textContent = 'Showing the curated first 10 reviews. Choose a topic to filter; click the same topic again for more.';
      if (empty) empty.hidden = true;
      return;
    }
    if (!qualified || !qualified.chips || !qualified.chips[topic]) {
      if (status) status.textContent = 'No qualified reviews available for "' + topic + '" yet.';
      reviewList.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    var ids = qualified.chips[topic];
    var offset = chipOffsets[topic] || 0;
    if (offset >= ids.length) offset = 0;  // wrap
    var picked = ids.slice(offset, offset + 10);
    if (picked.length < 10 && ids.length > picked.length) {
      // not enough remaining; fill from the beginning to keep 10 shown
      picked = picked.concat(ids.slice(0, 10 - picked.length));
    }
    chipOffsets[topic] = (offset + 10) % Math.max(1, ids.length);
    var html = '';
    picked.forEach(function (id) {
      var c = cardById(id);
      if (c) html += renderCard(c);
    });
    reviewList.innerHTML = html;
    if (status) {
      var label = topic.replace(/-/g, ' ');
      status.textContent = 'Showing 10 verified-photo reviews for "' + label + '". Click the chip again for the next 10.';
    }
    if (empty) empty.hidden = picked.length > 0;
  }

  chipFilterChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var topic = chip.getAttribute('data-topic');
      var sameAsActive = activeTopic === topic;
      if (!sameAsActive) {
        // Switching to a new chip — reset its offset so the user always sees
        // the highest-priority cards first when they switch back.
        chipOffsets[topic] = 0;
      }
      chipFilterChips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      activeTopic = topic;
      applyChipFilter(topic);
    });
  });

  // ===== Review modal: click any review-card photo to open the full review.
  var reviewModal = document.getElementById('armbrust-review-modal');
  if (reviewModal) {
    var rmPhoto = reviewModal.querySelector('[data-review-modal-photo]');
    var rmContent = reviewModal.querySelector('[data-review-modal-content]');
    var rmClose = reviewModal.querySelector('[data-review-modal-close]');

    function openReviewModal(card) {
      if (!card) return;
      var safe = function (s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      var stars = '★★★★★'.slice(0, card.rating);
      var date = card.date ? new Date(card.date).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'}) : '';
      var nameParts = (card.name || 'Customer').split(/\s+/);
      var display = nameParts[0] + (nameParts.length > 1 ? ' ' + nameParts[nameParts.length - 1][0].toUpperCase() + '.' : '');
      if (rmPhoto) {
        rmPhoto.src = card.photo || '';
        rmPhoto.alt = 'Customer review photo from ' + display;
      }
      if (rmContent) {
        rmContent.innerHTML =
          '<div class="ArmbrustPDP__ReviewModalMeta"><strong>' + safe(display) + '</strong>' +
          (date ? '<span>' + date + '</span>' : '') + '</div>' +
          '<div class="ArmbrustPDP__ReviewModalStars">' + stars + '</div>' +
          (card.title ? '<h3>' + safe(card.title) + '</h3>' : '') +
          '<p>' + safe(card.body) + '</p>';
      }
      reviewModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    window.__armbrustOpenReviewModal = openReviewModal;
    function closeReviewModal() {
      reviewModal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-open-review-modal]');
      if (!btn) return;
      var card = btn.closest('.ArmbrustReviewCard');
      if (!card) return;
      var id = card.getAttribute('data-review-id');
      var data = cardById(id);
      if (data) {
        e.preventDefault();
        e.stopPropagation();
        openReviewModal(data);
      }
    }, true);
    // Voice figures (in the "five reasons" section) are full-figure clickable:
    // anywhere inside opens the modal for that review.
    document.addEventListener('click', function (e) {
      var fig = e.target.closest && e.target.closest('.ArmbrustPDP__Voice[data-review-id]');
      if (!fig) return;
      var id = fig.getAttribute('data-review-id');
      var data = cardById(id);
      if (data) {
        e.preventDefault();
        e.stopPropagation();
        openReviewModal(data);
      }
    }, true);
    // Keyboard support for the voice-figure role="button" affordance.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var fig = e.target.closest && e.target.closest('.ArmbrustPDP__Voice[data-review-id]');
      if (!fig || document.activeElement !== fig) return;
      e.preventDefault();
      var data = cardById(fig.getAttribute('data-review-id'));
      if (data) openReviewModal(data);
    });
    if (rmClose) rmClose.addEventListener('click', closeReviewModal);
    reviewModal.addEventListener('click', function (e) {
      if (e.target === reviewModal) closeReviewModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !reviewModal.hidden) closeReviewModal();
    });
  }

  // ===== Photo + video modal.
  var modal = document.querySelector('.ArmbrustPDP__PhotoModal');
  if (!modal) return;
  var modalImg = modal.querySelector('[data-modal-image]');
  var modalVideo = modal.querySelector('[data-modal-video]');
  var modalCaption = modal.querySelector('[data-modal-caption]');
  var btnClose = modal.querySelector('.ArmbrustPDP__ModalClose');
  var btnPrev = modal.querySelector('.ArmbrustPDP__ModalArrow--prev');
  var btnNext = modal.querySelector('.ArmbrustPDP__ModalArrow--next');
  var photosContainer = modal.querySelector('[data-thumbs="photos"]');
  var videosContainer = modal.querySelector('[data-thumbs="videos"]');
  var tabButtons = modal.querySelectorAll('.ArmbrustPDP__ModalTab');

  // Hero image frame opens the modal at the current product photo.
  var triggers = Array.prototype.slice.call(document.querySelectorAll(
    '.ArmbrustPDP__HeroImageFrame'
  ));

  // Build two separate galleries: photos and videos. Each item carries its
  // caption (placeholder text added in HTML; replace per item).
  var rail = Array.prototype.slice.call(document.querySelectorAll(
    '.ArmbrustPDP__ThumbGrid button'
  ));

  var photos = [];
  var videos = [];
  var seen = {};

  rail.forEach(function (el) {
    var caption = el.getAttribute('data-caption') || '';
    if (el.classList.contains('has-video')) {
      var src = el.getAttribute('data-video');
      if (!src || seen[src]) return;
      seen[src] = true;
      var vimg = el.querySelector('img, video');
      var poster = el.getAttribute('data-poster') || (vimg && vimg.getAttribute('poster')) || '';
      var thumb = (vimg && (vimg.getAttribute('poster') || vimg.currentSrc || vimg.src)) || poster;
      videos.push({
        type: 'video',
        src: src,
        poster: poster,
        thumb: thumb,
        alt: el.getAttribute('aria-label') || 'Video',
        title: el.getAttribute('data-title') || '',
        caption: caption
      });
      return;
    }
    var img = el.querySelector('img');
    if (!img) return;
    var fsrc = img.getAttribute('data-full') || img.src;
    if (seen[fsrc]) return;
    seen[fsrc] = true;
    photos.push({
      type: 'image',
      src: fsrc,
      thumb: img.getAttribute('data-display') || img.src,
      alt: img.alt || '',
      caption: caption
    });
  });

  // Stamp counts onto the tabs.
  tabButtons.forEach(function (tb) {
    var c = tb.querySelector('[data-count]');
    if (!c) return;
    c.textContent = '(' + (tb.getAttribute('data-tab') === 'videos' ? videos.length : photos.length) + ')';
  });

  // Render thumbs into the correct container.
  var photoThumbs = [];
  var videoThumbs = [];

  function makeThumb(item, idx, group, container) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', (item.type === 'video' ? 'Play ' : 'View ') + (item.title || item.alt || 'item ' + (idx + 1)));
    if (item.type === 'video') btn.classList.add('is-video');

    if (item.type === 'video') {
      // Video tile: thumb + play overlay (left), title + description (right).
      btn.classList.add('ArmbrustPDP__VideoTile');
      var thumbWrap = document.createElement('span');
      thumbWrap.className = 'ArmbrustPDP__VideoTile__Thumb';
      var im = document.createElement('img');
      im.src = item.thumb;
      im.alt = item.title || item.alt;
      im.loading = 'lazy';
      thumbWrap.appendChild(im);
      btn.appendChild(thumbWrap);

      var textWrap = document.createElement('span');
      textWrap.className = 'ArmbrustPDP__VideoTile__Text';
      var title = document.createElement('span');
      title.className = 'ArmbrustPDP__VideoTile__Title';
      title.textContent = item.title || item.alt;
      var desc = document.createElement('span');
      desc.className = 'ArmbrustPDP__VideoTile__Desc';
      desc.textContent = item.caption || '';
      textWrap.appendChild(title);
      if (item.caption) textWrap.appendChild(desc);
      btn.appendChild(textWrap);
    } else {
      var imp = document.createElement('img');
      imp.src = item.thumb;
      imp.alt = item.alt;
      imp.loading = 'lazy';
      btn.appendChild(imp);
    }

    btn.addEventListener('click', function () { openAt(group, idx); });
    container.appendChild(btn);
    return btn;
  }

  photos.forEach(function (item, idx) {
    photoThumbs.push(makeThumb(item, idx, 'photos', photosContainer));
  });
  videos.forEach(function (item, idx) {
    videoThumbs.push(makeThumb(item, idx, 'videos', videosContainer));
  });

  var currentGroup = 'photos';
  var currentIdx = 0;

  function activeList() { return currentGroup === 'videos' ? videos : photos; }
  function activeThumbs() { return currentGroup === 'videos' ? videoThumbs : photoThumbs; }

  function showTab(group) {
    currentGroup = group;
    tabButtons.forEach(function (tb) {
      var on = tb.getAttribute('data-tab') === group;
      tb.classList.toggle('is-active', on);
      tb.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    photosContainer.hidden = group !== 'photos';
    videosContainer.hidden = group !== 'videos';
  }

  tabButtons.forEach(function (tb) {
    tb.addEventListener('click', function () {
      var group = tb.getAttribute('data-tab');
      if (group === currentGroup) return;
      // Switch tab WITHOUT changing the displayed media. User picks a thumb to swap.
      showTab(group);
    });
  });

  function syncActiveThumb() {
    activeThumbs().forEach(function (b, i) {
      b.classList.toggle('is-active', i === currentIdx);
    });
    // Clear active highlight in the inactive tab.
    var other = currentGroup === 'photos' ? videoThumbs : photoThumbs;
    other.forEach(function (b) { b.classList.remove('is-active'); });
  }

  function stopVideo() {
    if (!modalVideo) return;
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    modalVideo.hidden = true;
    modalImg.hidden = false;
  }

  function openAt(group, idx) {
    if (group !== currentGroup) showTab(group);
    var list = activeList();
    if (idx < 0) idx = list.length - 1;
    if (idx >= list.length) idx = 0;
    currentIdx = idx;
    var item = list[idx];
    if (!item) return;

    if (item.type === 'video') {
      modalImg.hidden = true;
      modalVideo.hidden = false;
      modalVideo.poster = item.poster || '';
      modalVideo.src = item.src;
      var p = modalVideo.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } else {
      stopVideo();
      modalImg.src = item.src;
      modalImg.alt = item.alt;
    }
    if (modalCaption) modalCaption.textContent = item.caption || '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    syncActiveThumb();
  }

  // Public helper: open the modal at an arbitrary image URL (used by the
  // customer photo grid and review-card image click handlers above).
  window.__armbrustOpenModalAt = function (url, alt) {
    if (!modal || !modalImg) return;
    stopVideo();
    modalImg.src = url;
    modalImg.alt = alt || '';
    modalImg.hidden = false;
    if (modalCaption) modalCaption.textContent = alt || '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };

  // Rail thumb routing.
  function openThumbAt(btn) {
    var img = btn.querySelector('img');
    if (!img) return;
    var src = img.getAttribute('data-full') || img.src;
    var idx = photos.findIndex(function (g) { return g.src === src; });
    if (idx < 0) idx = 0;
    openAt('photos', idx);
  }
  function openVideoThumb(btn) {
    var src = btn.getAttribute('data-video');
    var idx = videos.findIndex(function (g) { return g.src === src; });
    if (idx < 0) idx = 0;
    openAt('videos', idx);
  }
  function closeModal() {
    stopVideo();
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  triggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var img = el.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('data-full') || img.src;
      var idx = photos.findIndex(function (g) { return g.src === src; });
      if (idx < 0) idx = 0;
      openAt('photos', idx);
    });
  });

  btnClose.addEventListener('click', closeModal);
  btnPrev.addEventListener('click', function () { openAt(currentGroup, currentIdx - 1); });
  btnNext.addEventListener('click', function () { openAt(currentGroup, currentIdx + 1); });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') openAt(currentGroup, currentIdx - 1);
    if (e.key === 'ArrowRight') openAt(currentGroup, currentIdx + 1);
  });

  // ===== Review modal: clicking a review photo opens the full review.
  var reviewModal = document.querySelector('.ArmbrustPDP__ReviewModal');
  if (reviewModal) {
    var rmImg     = reviewModal.querySelector('.ArmbrustPDP__ReviewModalImage img');
    var rmName    = reviewModal.querySelector('.ArmbrustPDP__ReviewName strong');
    var rmStars   = reviewModal.querySelector('.ArmbrustPDP__StarsTitle .ArmbrustPDP__Stars');
    var rmTitle   = reviewModal.querySelector('.ArmbrustPDP__StarsTitle h3');
    var rmWhere   = reviewModal.querySelector('.ArmbrustPDP__ReviewWhere');
    var rmText    = reviewModal.querySelector('.ArmbrustPDP__ReviewText');
    var rmClose   = reviewModal.querySelector('.ArmbrustPDP__ReviewModalClose');

    function openReview(card, imgEl) {
      if (!card) return;
      rmImg.src = imgEl.getAttribute('data-full') || imgEl.src;
      rmImg.alt = imgEl.alt || '';
      var nameNode = card.querySelector('.ArmbrustPDP__ReviewName strong');
      var starsNode = card.querySelector('.ArmbrustPDP__StarsTitle .ArmbrustPDP__Stars');
      var titleNode = card.querySelector('.ArmbrustPDP__StarsTitle h3');
      var whereNode = card.querySelector('.ArmbrustPDP__ReviewWhere');
      var textNode = card.querySelector('.ArmbrustPDP__ReviewText');
      rmName.textContent  = nameNode  ? nameNode.textContent  : '';
      rmStars.textContent = starsNode ? starsNode.textContent : '';
      rmTitle.textContent = titleNode ? titleNode.textContent : '';
      rmWhere.textContent = whereNode ? whereNode.textContent : '';
      rmText.textContent  = textNode  ? textNode.textContent  : '';
      reviewModal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeReview() {
      reviewModal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('.ArmbrustPDP__ReviewCard .ArmbrustPDP__ReviewPhotos button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.ArmbrustPDP__ReviewCard');
        var im = btn.querySelector('img');
        openReview(card, im);
      });
    });

    rmClose.addEventListener('click', closeReview);
    reviewModal.addEventListener('click', function (e) {
      if (e.target === reviewModal) closeReview();
    });
    document.addEventListener('keydown', function (e) {
      if (!reviewModal.hidden && e.key === 'Escape') closeReview();
    });
  }
})();
